import { render } from "./GuideFolding.vue?vue&type=template&id=78c6e7f1&scoped=true"
import script from "./GuideFolding.vue?vue&type=script&lang=js"
export * from "./GuideFolding.vue?vue&type=script&lang=js"

import "./GuideFolding.vue?vue&type=style&index=0&id=78c6e7f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c6e7f1"]])

export default __exports__